(ns app.front.view.group.admin.files
  (:require [app.front.entities :as entities]
            [app.front.file.upload :as upload]
            [app.front.ui :as ui]
            [app.front.ui.table :as ui-table]
            [app.front.util :refer [for-all]]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.group.admin.verdict-template.events :as vte]
            [core.front.comm :as comm]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(rf/reg-event-fx
  ::fetch-files
  (fn [_ [_ group-id]]
    {:comm/command {:command    :file/list-group-files
                    :method     :get
                    :data       {:group-id group-id}
                    :on-success [::entities/merge-entity-db]}}))

(rf/reg-event-fx
  ::verdict-page-uploaded
  (fn [_ [_ group-id section-id status response]]
    (let [file-id (ffirst response)]
      {:dispatch-n [[::entities/merge-entity-db status response]
                    [::vte/update-section
                     group-id section-id {:file-id file-id}]]})))

(rf/reg-event-fx
  ::delete-file
  (fn [_ [_ group-id file-id]]
    {:comm/command {:command    :file/delete-group-file
                    :data       {:group-id group-id
                                 :file-id  file-id}
                    :on-success [::delete-file-success]}}))

(rf/reg-event-fx
  ::delete-file-success
  (fn [_ [_ _ {:keys [removed-entity]}]]
    {:dispatch-n [[::entities/remove-entity removed-entity]
                  [:notifications/add :toast :success :success ""]]}))

(defn- add-image [group-id existing-filenames file-id filename content-type md5]
  (if (contains? existing-filenames filename)
    (>evt [:notifications/add :toast :error :error/image-already-exists :error/image-must-be-unique])
    (comm/send-command-execution
      {:command    :file/add-group-file
       :data       {:group-id          group-id
                    :file-id           file-id
                    :file/filename     filename
                    :file/content-type content-type
                    :file/category     :file.category/verdict-image
                    :file/md5          md5}
       :on-success [::entities/merge-entity-db]})))

(defn- add-verdict-page [group-id section-id file-id filename content-type md5]
  (if (= content-type "application/pdf")
    (comm/send-command-execution
      {:command    :file/add-group-file
       :data       {:group-id          group-id
                    :file-id           file-id
                    :file/filename     filename
                    :file/content-type content-type
                    :file/category     :file.category/verdict-page
                    :file/md5          md5}
       :on-success [::verdict-page-uploaded group-id section-id]})
    (>evt [:notifications/add :toast :error :error/invalid-file-type :error/file-must-be-pdf])))

(defn file-link [group-id file-id & [download?]]
  (str
    "/api/command/file/download-group-file?group-id=" group-id
    "&file-id=" file-id
    (when download?
      "&download=true")))

(defn sort-rows [[attr descending?] rows]
  (if attr
    (sort-by #(get % attr) (if descending? > <) rows)
    rows))

(defn verdict-template-images [group-id]
  (r/with-let [*sorting (r/atom [])]
    (let [tr        (<sub [:tr])
          images    (->> (<sub [::gas/editable-verdict-images group-id])
                         (sort-rows @*sorting))
          filenames (-> (map :file/filename images)
                        set)]
      [:div
       [:div.mt-6.mb-6
        [upload/upload-button "verdict-template-image" {:attach-file-fn  (partial add-image group-id filenames)
                                                        :button-i18n-key :file/upload-new-image
                                                        :accept-types    ["image/*"]}]]
       (when (seq images)
         #_{:clj-kondo/ignore [:deprecated-var]}
         [ui-table/table {:tr tr :expandable? true}
          [[ui-table/table-header-sortable tr *sorting :file/filename]
           [ui-table/table-header-sortable tr *sorting :file/content-type]
           [:th ""]]
          (for-all [{:db/keys [id] :as image} images]
            {:key              (str id)
             :cols             [{:content (:file/filename image)}
                                {:content (:file/content-type image)}
                                {:opts    {:class-name "table-row__actions"}
                                 :content [:<>
                                           [ui/modal-confirmation-button {:tr                tr
                                                                          :id                "delete-image"
                                                                          :modal-title       (tr [:image/delete])
                                                                          :trigger-icon-opts {:icon        i/trash
                                                                                              :description (tr [:image/delete])
                                                                                              :class-name  "cursor-pointer"}
                                                                          :on-yes-click      #(>evt [::delete-file group-id id])}
                                            (tr [:image/delete-confirm])]]}]
             :expanded-content [:img.verdict-image-preview {:src (file-link group-id id)}]})])])))

(defn verdict-static-page-upload [section-id group-id]
  [upload/upload-button (str "verdict-template-page-" section-id)
   {:attach-file-fn  (partial add-verdict-page group-id section-id)
    :button-i18n-key :file/upload-new-pdf
    :accept-types    [".pdf" "application/pdf"]}])
